import {
  COLORS,
  POSITIONS,
  classNames,
  toClassName,
} from "@result/rui/utils/component";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const NavButton = ({
  to,
  state,
  label,
  leftIcon,
  rightIcon,
  color = "primary",
  size,
  tooltip,
  tooltipPosition,
  tooltipAlign,
  tooltipColor,
  disabled,
  ...props
}) => {
  return (
    <NavLink
      to={to}
      state={state}
      {...props}
      role="button"
      className={classNames(
        `button is-${color} ${size || ""}`,
        toClassName(!!tooltip, "has-tooltip-arrow"),
        POSITIONS[tooltipPosition].tooltip,
        POSITIONS[tooltipAlign].tooltipAlign,
        COLORS[tooltipColor].tooltip,
        {
          "is-disabled": disabled,
        }
      )}
      data-tooltip={tooltip}
      disabled={disabled}
      aria-disabled={disabled}>
      {leftIcon && (
        <span className="icon is-small">
          <i className={leftIcon}></i>
        </span>
      )}
      {label && <span>{label}</span>}
      {rightIcon && (
        <span className="icon is-small">
          <i className={rightIcon}></i>
        </span>
      )}
    </NavLink>
  );
};

NavButton.propTypes = {
  to: PropTypes.string.isRequired,
  state: PropTypes.object,
  label: PropTypes.string,
  leftIcon: PropTypes.string,
  color: PropTypes.oneOf([
    "primary",
    "link",
    "info",
    "success",
    "warning",
    "danger",
  ]),
  size: PropTypes.oneOf(["is-small", "is-medium", "is-large"]),
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  tooltipAlign: PropTypes.oneOf(["left", "right"]),
  tooltipColor: PropTypes.oneOf([
    "primary",
    "link",
    "success",
    "info",
    "warning",
    "danger",
    "light",
    "dark",
    "white",
    "black",
  ]),
};

export default NavButton;
